// extracted by mini-css-extract-plugin
export default {"root":"src-views-singleAssetStoryEditor-containers-SnapPublisherWithBar-SnapPublisherWithBar__root--YPRGx"};